import { BinTypeEnum } from '../../../model/cleaningService/binType/binTypeEnum';

export const getInputCountNameByBinType = (binType: BinTypeEnum) => {
    return 'count' + binType.toString();
};

export const getInputCleaningFrequencyNameByBinType = (binType: BinTypeEnum) => {
    return 'cleaningFrequency' + binType.toString();
};
